import { css } from 'aphrodite';
import _ from 'lodash';

import { Layout } from './Styles';

export default function scrollContainersToTop() {
  [css(Layout.fullScrollingContentArea), css(Layout.scrollingContentArea)].forEach((containerClass) => {
    _(document.getElementsByClassName(containerClass)).forEach((elem) => {
      elem.scrollTop = 0;
    });
  });
}



// WEBPACK FOOTER //
// ./src/ScrollFix.js